import React from "react";
import {
  BARTER_CATEGORY_OPTIONS,
  EXCHANGE_TYPE_OPTIONS,
  EXCHANGE_TYPES,
} from "../../utils/barter";

const BarterExchangeSection = ({ value, onChange, title = "Exchange options" }) => {
  const fields = {
    exchangeType: EXCHANGE_TYPES.CASH_ONLY,
    barterOpenToAnything: false,
    barterCategories: [],
    barterNotes: "",
    ...value,
  };
  const barterEnabled =
    fields.exchangeType === EXCHANGE_TYPES.CASH_OR_TRADE ||
    fields.exchangeType === EXCHANGE_TYPES.TRADE_ONLY;

  const update = (patch) => {
    const next = { ...fields, ...patch };
    const canTrade =
      next.exchangeType === EXCHANGE_TYPES.CASH_OR_TRADE ||
      next.exchangeType === EXCHANGE_TYPES.TRADE_ONLY;

    onChange({
      ...next,
      barterEnabled: canTrade,
      barterOpenToAnything: canTrade ? next.barterOpenToAnything === true : false,
      barterCategories: canTrade ? next.barterCategories || [] : [],
      barterNotes: canTrade ? next.barterNotes || "" : "",
    });
  };

  const toggleCategory = (category) => {
    const current = Array.isArray(fields.barterCategories) ? fields.barterCategories : [];
    update({
      barterCategories: current.includes(category)
        ? current.filter((item) => item !== category)
        : [...current, category],
    });
  };

  return (
    <div className="barter-section">
      <div className="edit-section-heading compact">
        <h3>{title}</h3>
        <p>Only offer legal, safe, local trades. Meet safely and use your own judgment.</p>
      </div>

      <label className="form-label">
        Cash, trade, or free
        <select
          value={fields.exchangeType}
          onChange={(event) => update({ exchangeType: event.target.value })}
        >
          {EXCHANGE_TYPE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>

      {barterEnabled && (
        <>
          <label className="farm-stand-toggle barter-any-toggle">
            <input
              type="checkbox"
              checked={fields.barterOpenToAnything === true}
              onChange={(event) => update({ barterOpenToAnything: event.target.checked })}
            />
            Open to any fair trade
          </label>

          {!fields.barterOpenToAnything && (
            <div className="barter-category-grid" aria-label="Trade categories">
              {BARTER_CATEGORY_OPTIONS.map((option) => (
                <label key={option.value} className="barter-category-chip">
                  <input
                    type="checkbox"
                    checked={(fields.barterCategories || []).includes(option.value)}
                    onChange={() => toggleCategory(option.value)}
                  />
                  {option.label}
                </label>
              ))}
            </div>
          )}

          <label className="form-label">
            Trade notes optional
            <textarea
              value={fields.barterNotes || ""}
              onChange={(event) => update({ barterNotes: event.target.value })}
              maxLength={500}
              rows={3}
              placeholder="Open to eggs, plants, feed, handmade goods, livestock help, or fair offers."
            />
          </label>
        </>
      )}
    </div>
  );
};

export default BarterExchangeSection;
